import { twMerge } from 'tailwind-merge';

/**
 * Raised content card (Figma "Default-card"): #fcfcfc fill, 4px white border,
 * radius/card, Elevation/300 — all supplied by the .card-raised utility.
 */
export function Card({
  as: Component = 'div',
  selected = false,
  className,
  ...props
}) {
  return (
    <Component
      className={twMerge(
        'card-raised p-4',
        selected && 'bg-card-selected',
        className
      )}
      {...props}
    />
  );
}
